<div class="container">
  <div class="tutorial-head">
    <div class="head-left">
      <div class="content-head2">
        <h4 class="contentname marginunset _subheading" style="color: #2898cb">{{
          'Tutorial.contentname' | translate
        }}</h4>
      </div>
      <div class="content-head">
        <h4 class="contentname marginunset _subheading" style="color: #2898cb">{{
          'Tutorial.contentname' | translate
        }}</h4>
      </div>
      <ng-container *ngIf="!isTutorialVideo2021">
        <h1 class="new-headtext marginunset _heading">{{ 'NewLanding.tutorial.headtext' | translate }}</h1>
        <div class="new-detailtext">{{ 'NewLanding.tutorial.detailtext' | translate }}</div>
      </ng-container>

      <ng-container *ngIf="isTutorialVideo2021">
        <h1 class="new-headtext marginunset _heading">{{ 'tuterialVideo2021.heading_top_title' | translate }}</h1>
        <div class="new-detailtext">{{ 'tuterialVideo2021.heading_top_detail' | translate }}</div>
      </ng-container>

      <div class="wrapper-download">
        <a
          href="https://flowaccountcdn.com/assets/images/tutorials/วิธีการใช้โปรแกรม%20%20FLOW%20ADVANCE.pdf"
          target="_blank"
          rel="nofollow"
          download="วิธีการใช้โปรแกรม FlowAdvance.pdf"
          style="text-decoration: unset"
        >
          <!-- ปุ่มดาวน์โหลดคู่มือไม่ได้อัพเดทนาน คอมเม้นไว้ก่อน เผื่ออนาคตมีการอัพเดทคู่มือค่อยเปิดปุ่มดาวน์โหลด -->
          <!-- <div class="button-download">
            <i class="far fa-file-alt"></i>&nbsp;&nbsp;{{ 'Tutorials.Download' | translate }}
          </div> -->
        </a>
      </div>
    </div>
    <div
      class="head-right"
      (click)="translate.currentLang === 'th' ? linkVideo('1CQelL-bZC4') : linkVideo('8Gw81bBT720')"
      data-toggle="modal"
      data-target="#functionVideo"
    >
      <div class="bgdrop"></div>
      <picture>
        <source
          srcset="
            https://flowaccountcdn.com/new_landing/image/tutorials/SS1/FlowAccount%20Business%20Suite%20ระบบริหารธุรกิจ%20SME.webp
          "
          type="image/webp"
        />
        <source
          srcset="
            https://flowaccountcdn.com/new_landing/image/tutorials/SS1/FlowAccount%20Business%20Suite%20ระบบริหารธุรกิจ%20SME.jpg
          "
          type="image/jpeg"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/tutorials/SS1/FlowAccount%20Business%20Suite%20ระบบริหารธุรกิจ%20SME.jpg"
          width="100%"
          alt="{{ showAltText('วิธีใช้โปรแกรมบัญชี FlowAccount', 'FlowAccount Business Suite') }}"
          loading="lazy"
        />
      </picture>

      <div class="icon-position">
        <img
          class="icon-play"
          src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
          alt="FlowAccount Play"
        />
      </div>
    </div>
  </div>

  <ng-container *ngIf="isTutorialVideo2021">
    <div class="tutorial-content u-border-bottom" *ngFor="let catagory of categories">
      <div class="content-head">{{ catagory[translate.currentLang].title }}</div>
      <div class="content-detail">{{ catagory[translate.currentLang].description }}</div>

      <!-- Logic การแสดเง Video ระหว่าง Category กับ Sub Category -->
      <ng-container *ngIf="catagory.sub_categories; then subCategoryVideo; else categoryVideo"> </ng-container>

      <ng-template #categoryVideo>
        <ng-container *ngTemplateOutlet="video; context: { list: catagory }"> </ng-container>
      </ng-template>

      <ng-template #subCategoryVideo>
        <div class="boderBT50" *ngFor="let sub_category of catagory.sub_categories">
          <div class="subhead">{{ sub_category.title[translate.currentLang] }}</div>
          <ng-container *ngTemplateOutlet="video; context: { list: sub_category }"> </ng-container>
        </div>
      </ng-template>
    </div>
  </ng-container>

  <!-- ส่วนสำหรับแสดง Video -->
  <ng-template #video let-category="list">
    <div class="view-video">
      <div class="video-banner" *ngFor="let item of getCategoryVideo(category.category_no)">
        <a [routerLink]="['viewtutorial', item.slugURL]" target="_blank" rel="noopener">
          <div class="video-img">
            <div class="bgdrop"></div>
            <picture>
              <source srcset="{{item.banner_webp}}" type="image/webp" />
              <source srcset="{{item.banner}}" type="image/jpeg" />
              <img src="{{ item.banner }}" width="100%" alt="{{ item.alt }}" loading="lazy" />
            </picture>

            <div class="icon-position">
              <img
                class="icon-play"
                src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                alt="play"
                loading="lazy"
              />
            </div>
          </div>
          <div class="video-title">{{ translate.currentLang === 'th' ? item.title : item.title_en }}</div>
        </a>
      </div>
    </div>
  </ng-template>

  <!-- START: เนื้อหาก่อนปี 2021 ไม่แสดงผล -->
  <ng-container *ngIf="!isTutorialVideo2021">
    <div class="tutorial-content" style="border-bottom: 1px solid #ebebeb">
      <div class="content-head">{{ 'Tutorial.head1' | translate }}</div>
      <div class="content-detail">{{ 'Tutorial.head1_detail' | translate }}</div>
      <div class="view-video">
        <div class="video-banner" *ngFor="let i of carrerVideo">
          <a
            [routerLink]="[
              'viewtutorial',
              translate.currentLang === 'th' ? strReplace(i.title) : strReplace(i.title_en)
            ]"
            target="_blank"
          >
            <div class="video-img">
              <div class="bgdrop"></div>
              <picture>
                <source srcset="{{i.banner}}" type="image/webp" />
                <source srcset="{{i.banner}}" type="image/jpeg" />
                <img src="{{ i.banner }}" width="100%" [alt]="i.alt" />
              </picture>

              <div class="icon-position">
                <img
                  class="icon-play"
                  src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  alt="play"
                />
              </div>
            </div>
            <div class="video-title">{{ translate.currentLang === 'th' ? i.title : i.title_en }}</div>
          </a>
        </div>
      </div>
    </div>

    <div class="tutorial-content">
      <div class="content-head">{{ 'Tutorial.head2' | translate }}</div>
      <div class="content-detail">{{ 'Tutorial.head2_detail' | translate }}</div>
      <!-- เอกสารขาย และซื้อ -->
      <div class="boderBT50">
        <div class="subhead">{{ 'Tutorial.subhead1' | translate }}</div>
        <div class="view-video pt20">
          <div class="video-banner" *ngFor="let i of saleAndPurchaseVideo">
            <a
              [routerLink]="[
                'viewtutorial',
                translate.currentLang === 'th' ? strReplace(i.title) : strReplace(i.title_en)
              ]"
              target="_blank"
            >
              <div class="video-img">
                <div class="bgdrop"></div>
                <picture>
                  <source srcset="{{i.banner}}" type="image/webp" />
                  <source srcset="{{i.banner}}" type="image/jpeg" />
                  <img src="{{ i.banner }}" width="100%" [alt]="i.alt" />
                </picture>
                <div class="icon-position">
                  <img
                    class="icon-play"
                    src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                    alt="play"
                  />
                </div>
              </div>
              <div class="video-title">{{ translate.currentLang === 'th' ? i.title : i.title_en }}</div>
            </a>
          </div>
        </div>
      </div>
      <!-- บริหารเงินเดือน เอกสารซื้อ และค่าใช้จ่าย -->
      <div class="boderBT50">
        <div class="subhead pt50">{{ 'Tutorial.subhead2' | translate }}</div>
        <div class="view-video pt20">
          <div class="video-banner" *ngFor="let i of payrollVideo">
            <a
              [routerLink]="[
                'viewtutorial',
                translate.currentLang === 'th' ? strReplace(i.title) : strReplace(i.title_en)
              ]"
              target="_blank"
            >
              <div class="video-img">
                <div class="bgdrop"></div>
                <picture>
                  <source srcset="{{i.banner}}" type="image/webp" />
                  <source srcset="{{i.banner}}" type="image/jpeg" />
                  <img src="{{ i.banner }}" width="100%" [alt]="i.alt" />
                </picture>
                <div class="icon-position">
                  <img
                    class="icon-play"
                    src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                    alt="play"
                  />
                </div>
              </div>
              <div class="video-title">{{ translate.currentLang === 'th' ? i.title : i.title_en }}</div>
            </a>
          </div>
        </div>
      </div>
      <!-- ข้อมูลสินค้า และสมุดรายชื่อ -->
      <div class="boderBT50">
        <div class="subhead pt50">{{ 'Tutorial.subhead3' | translate }}</div>
        <div class="view-video pt20">
          <div class="video-banner" *ngFor="let i of inventoryVideo">
            <a
              [routerLink]="[
                'viewtutorial',
                translate.currentLang === 'th' ? strReplace(i.title) : strReplace(i.title_en)
              ]"
              target="_blank"
            >
              <div class="video-img">
                <div class="bgdrop"></div>
                <picture>
                  <source srcset="{{i.banner}}" type="image/webp" />
                  <source srcset="{{i.banner}}" type="image/jpeg" />
                  <img src="{{ i.banner }}" width="100%" [alt]="i.alt" />
                </picture>
                <div class="icon-position">
                  <img
                    class="icon-play"
                    src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                    alt="play"
                  />
                </div>
              </div>
              <div class="video-title">{{ translate.currentLang === 'th' ? i.title : i.title_en }}</div>
            </a>
          </div>
        </div>
      </div>
      <!-- รายงาน -->
      <div class="boderBT50">
        <div class="subhead pt50">{{ 'Tutorial.subhead4' | translate }}</div>
        <div class="view-video pt20">
          <div class="video-banner" *ngFor="let i of reportVideo">
            <a
              [routerLink]="[
                'viewtutorial',
                translate.currentLang === 'th' ? strReplace(i.title) : strReplace(i.title_en)
              ]"
              target="_blank"
            >
              <div class="video-img">
                <div class="bgdrop"></div>
                <picture>
                  <source srcset="{{i.banner}}" type="image/webp" />
                  <source srcset="{{i.banner}}" type="image/jpeg" />
                  <img src="{{ i.banner }}" width="100%" [alt]="i.alt" />
                </picture>
                <div class="icon-position">
                  <img
                    class="icon-play"
                    src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                    alt="play"
                  />
                </div>
              </div>
              <div class="video-title">{{ translate.currentLang === 'th' ? i.title : i.title_en }}</div>
            </a>
          </div>
        </div>
      </div>
      <!-- บริหารบัญชี -->
      <div class="boderBT50">
        <div class="subhead pt50">{{ 'Tutorial.subhead5' | translate }}</div>
        <div class="view-video pt20">
          <div class="video-banner" *ngFor="let i of accountingManagementVideo">
            <a
              [routerLink]="[
                'viewtutorial',
                translate.currentLang === 'th' ? strReplace(i.title) : strReplace(i.title_en)
              ]"
              target="_blank"
            >
              <div class="video-img">
                <div class="bgdrop"></div>
                <picture>
                  <source srcset="{{i.banner}}" type="image/webp" />
                  <source srcset="{{i.banner}}" type="image/jpeg" />
                  <img src="{{ i.banner }}" width="100%" [alt]="i.alt" />
                </picture>
                <div class="icon-position">
                  <img
                    class="icon-play"
                    src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                    alt="play"
                  />
                </div>
              </div>
              <div class="video-title">{{ translate.currentLang === 'th' ? i.title : i.title_en }}</div>
            </a>
          </div>
        </div>
      </div>
      <!-- รายงานด้านบัญชี -->
      <div class="boderBT50">
        <div class="subhead pt50">{{ 'Tutorial.subhead6' | translate }}</div>
        <div class="view-video pt20">
          <div class="video-banner" *ngFor="let i of accountingReportVideo">
            <a
              [routerLink]="[
                'viewtutorial',
                translate.currentLang === 'th' ? strReplace(i.title) : strReplace(i.title_en)
              ]"
              target="_blank"
            >
              <div class="video-img">
                <div class="bgdrop"></div>
                <picture>
                  <source srcset="{{i.banner}}" type="image/webp" />
                  <source srcset="{{i.banner}}" type="image/jpeg" />
                  <img src="{{ i.banner }}" width="100%" [alt]="i.alt" />
                </picture>
                <div class="icon-position">
                  <img
                    class="icon-play"
                    src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                    alt="play"
                  />
                </div>
              </div>
              <div class="video-title">{{ translate.currentLang === 'th' ? i.title : i.title_en }}</div>
            </a>
          </div>
        </div>
      </div>
      <!-- การตั้งค่า -->
      <div class="boderBT50" style="border-bottom: unset">
        <div class="subhead pt50">{{ 'Tutorial.subhead7' | translate }}</div>
        <div class="view-video pt20">
          <div class="video-banner" *ngFor="let i of settingVideo">
            <a
              [routerLink]="[
                'viewtutorial',
                translate.currentLang === 'th' ? strReplace(i.title) : strReplace(i.title_en)
              ]"
              target="_blank"
            >
              <div class="video-img">
                <div class="bgdrop"></div>
                <picture>
                  <source srcset="{{i.banner}}" type="image/webp" />
                  <source srcset="{{i.banner}}" type="image/jpeg" />
                  <img src="{{ i.banner }}" width="100%" [alt]="i.alt" />
                </picture>
                <div class="icon-position">
                  <img
                    class="icon-play"
                    src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                    alt="play"
                  />
                </div>
              </div>
              <div class="video-title">{{ translate.currentLang === 'th' ? i.title : i.title_en }}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- END: เนื้อหาก่อนปี 2021 ไม่แสดงผล -->
</div>

<flowaccount-blog-swiper-squidex
  [customHeader]="customHeader"
  [lang]="translate.currentLang"
  [contentSquidex]="'tutorials-blog'"
  [contentScully]="'tutorials-blog-key'"
></flowaccount-blog-swiper-squidex>
